import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const AuthRedirect: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const idToken = sessionStorage.getItem("idToken");
    const currentPath = window.location.pathname;
    const authPaths = ['/sign-in', '/new-password', '/reset-password', '/reset-code'];

    if (idToken && authPaths.includes(currentPath)) {
      navigate('/');
    } else if (!idToken && currentPath === '/') {
      navigate('/sign-in');
    }
  }, [navigate]);

  return null;
};